import { QueryClient } from '@tanstack/react-query';

/**
 * Single source of server state. UI state lives in Zustand — never mirror
 * server data into a store.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
